var _excluded = ["showTotal", "showJump", "disabled", "useText", "page", "pageSize", "pageSizeList", "wrapNums", "total", "className", "size", "filled", "renderTotal", "renderPageSizeItem", "pageSizeSelectWidth", "onPageChange", "onPageSizeChange"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import React, { Fragment, useCallback, useState } from 'react';
import { classnames, format, getUniqueKey } from '@okee-uikit/react-utils';
import { DEFAULT_CONFIG, useLocale, usePrefixCls } from '@okee-uikit/react-config';
import { Left, Right } from '../../common/icons';
import { Input } from '../input';
import { Select } from '../select';
import { PagerSimple } from './PagerSimple';
var PLACEHOLDER = '···';

function getPageItemData(page) {
  return {
    label: "".concat(page),
    index: page,
    childEle: React.createElement("span", null, page)
  };
}

function getPageItemPlaceHolder(page) {
  return {
    label: PLACEHOLDER,
    index: page,
    childEle: React.createElement("span", {
      className: "".concat(DEFAULT_CONFIG.prefixCls, "-pager-apostrophe-cell")
    }, PLACEHOLDER)
  };
}

function getPaginationList(index, pageCount, wrapNums) {
  var blockLength = wrapNums * 2 + 1;
  var maxBlockIndex = Math.max(pageCount - blockLength, 0);
  var blockStartIndex = Math.max(index - wrapNums - 1, 0);
  var blockEndIndex = blockStartIndex + blockLength - 1;
  var paginationList = new Array();

  if (maxBlockIndex < 2) {
    paginationList.push.apply(paginationList, _toConsumableArray(generatePageItem(1, pageCount)));
  } else {
    if (blockStartIndex < maxBlockIndex) {
      if (blockStartIndex < 2) {
        paginationList.push.apply(paginationList, _toConsumableArray(generatePageItem(1, blockEndIndex + 1)));
      } else {
        paginationList.push(getPageItemData(1));
        paginationList.push(getPageItemPlaceHolder(blockStartIndex));
        paginationList.push.apply(paginationList, _toConsumableArray(generatePageItem(blockStartIndex + 1, blockEndIndex + 1)));
      }

      if (pageCount - blockEndIndex - 1 - 1 > 0) {
        paginationList.push(getPageItemPlaceHolder(blockEndIndex + 1 + 1));
      }

      paginationList.push(getPageItemData(pageCount));
    } else {
      paginationList.push(getPageItemData(1));
      paginationList.push(getPageItemPlaceHolder(blockStartIndex));
      paginationList.push.apply(paginationList, _toConsumableArray(generatePageItem(maxBlockIndex + 1, pageCount)));
    }
  }

  paginationList.unshift({
    disabled: index === 1,
    label: '<',
    index: -1,
    childEle: React.createElement(Left, null)
  });
  paginationList.push({
    disabled: index === pageCount,
    label: '>',
    index: -2,
    childEle: React.createElement(Right, null)
  });
  return paginationList;
}

function generatePageItem(start, end) {
  var paginationList = new Array();

  for (var i = start; i <= end; i++) {
    paginationList.push(getPageItemData(i));
  }

  return paginationList;
}

export function Pager(props) {
  var _props$showTotal = props.showTotal,
      showTotal = _props$showTotal === void 0 ? false : _props$showTotal,
      _props$showJump = props.showJump,
      showJump = _props$showJump === void 0 ? false : _props$showJump,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$useText = props.useText,
      useText = _props$useText === void 0 ? false : _props$useText,
      _props$page = props.page,
      page = _props$page === void 0 ? 1 : _props$page,
      _props$pageSize = props.pageSize,
      pageSize = _props$pageSize === void 0 ? 10 : _props$pageSize,
      _props$pageSizeList = props.pageSizeList,
      pageSizeList = _props$pageSizeList === void 0 ? [] : _props$pageSizeList,
      _props$wrapNums = props.wrapNums,
      wrapNums = _props$wrapNums === void 0 ? 2 : _props$wrapNums,
      _props$total = props.total,
      total = _props$total === void 0 ? 0 : _props$total,
      className = props.className,
      _props$size = props.size,
      size = _props$size === void 0 ? 'xs' : _props$size,
      _props$filled = props.filled,
      filled = _props$filled === void 0 ? false : _props$filled,
      renderTotal = props.renderTotal,
      renderPageSizeItem = props.renderPageSizeItem,
      pageSizeSelectWidth = props.pageSizeSelectWidth,
      onPageChange = props.onPageChange,
      onPageSizeChange = props.onPageSizeChange,
      others = _objectWithoutProperties(props, _excluded);

  var localeJump = useLocale('pager.jump');
  var localeTotal = useLocale('pager.total');
  var pageCount = Math.ceil(total / pageSize);
  var maxPageSizeLen = pageSizeList.length > 0 ? Math.max.apply(Math, _toConsumableArray(pageSizeList)).toString().length : 0;
  var pagerSelectWidth = "".concat(pageSizeSelectWidth || 88 + (maxPageSizeLen >= 2 ? (maxPageSizeLen - 2) * 7 : 0), "px");
  var cls = classnames(usePrefixCls('pager', {
    size: size,
    disabled: disabled,
    filled: filled
  }), className);
  var itemGroupCls = usePrefixCls('pager-item-group');
  var textCls = usePrefixCls('pager-text');
  var itemCls = usePrefixCls('pager-item');
  var itemCheckedCls = usePrefixCls('pager-item-checked');
  var itemDisabledCls = usePrefixCls('pager-item-disabled');
  var jumpAreaCls = usePrefixCls('pager-jump-area');
  var jumpInputCls = usePrefixCls('pager-jump-input');
  var jumpCls = usePrefixCls('pager-jump');
  var pageRecordCls = usePrefixCls('pager-record');

  var setCurrentIndex = function setCurrentIndex(index) {
    !disabled && onPageChange && onPageChange(index);
  };

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      inputVal = _useState2[0],
      setInputVal = _useState2[1];

  var onSelectChange = useCallback(function (jumpSize) {
    if (jumpSize == null) {
      return;
    }

    var newPageCount = Math.ceil(total / jumpSize);
    var newAutoPage = Math.min(page, newPageCount);
    onPageSizeChange && onPageSizeChange(newAutoPage, jumpSize);
  }, [page, onPageChange]);

  var onItemClick = function onItemClick(idx) {
    var next = page + 1;
    var pre = page - 1;

    switch (idx) {
      case -1:
        pre > 0 && setCurrentIndex(pre);
        break;

      case -2:
        next <= pageCount && setCurrentIndex(next);
        break;

      default:
        idx !== page && setCurrentIndex(idx);
        break;
    }
  };

  var sizeLocale = useLocale('pager.size');

  var renderPageNumber = function renderPageNumber() {
    var pageItemList = getPaginationList(page, pageCount, wrapNums < 1 ? 1 : Math.ceil(wrapNums));
    return React.createElement("ul", {
      className: itemGroupCls
    }, pageItemList.map(function (item) {
      var basicClass = useText ? textCls : itemCls;
      var disCls = classnames(basicClass, _defineProperty({}, itemCheckedCls, item.index === page), _defineProperty({}, itemDisabledCls, item.disabled === true || total === 0 && pageCount === 0));
      return React.createElement("li", {
        key: getUniqueKey(item),
        className: disCls,
        onClick: function onClick() {
          onItemClick(item.index);
        }
      }, item.childEle);
    }));
  };

  var renderPageSizeSelector = function renderPageSizeSelector() {
    if (pageSizeList.length) {
      return React.createElement(Select, {
        size: size,
        value: pageSize,
        width: pagerSelectWidth,
        disabled: disabled,
        onChange: onSelectChange
      }, pageSizeList.map(function (item) {
        return React.createElement(Select.Option, {
          key: getUniqueKey(item),
          value: item,
          label: format(sizeLocale, {
            count: item
          })
        }, renderPageSizeItem ? renderPageSizeItem(item) : format(sizeLocale, {
          count: item
        }));
      }));
    }

    return null;
  };

  var resetInputVal = function resetInputVal() {
    var index;
    var numInputVal = +inputVal;

    if (numInputVal > 0) {
      index = numInputVal > pageCount ? pageCount : numInputVal;
      setCurrentIndex(index);
    }

    setInputVal('');
  };

  var onInputEnter = function onInputEnter() {
    resetInputVal();
  };

  var onInputChange = function onInputChange(val) {
    setInputVal(val);
  };

  var onJumpPageClick = function onJumpPageClick() {
    resetInputVal();
  };

  var renderJumpTo = function renderJumpTo() {
    return React.createElement(React.Fragment, null, React.createElement("span", {
      className: jumpAreaCls
    }, React.createElement(Input, {
      size: size,
      style: {
        width: '56px'
      },
      disabled: disabled,
      value: inputVal,
      className: jumpInputCls,
      onPressEnter: onInputEnter,
      onValueChange: onInputChange,
      placeholder: ""
    })), React.createElement("span", {
      className: jumpCls,
      onClick: onJumpPageClick
    }, localeJump));
  };

  var getTotal = function getTotal() {
    if (!showTotal) {
      return React.createElement(Fragment, null);
    }

    return React.createElement("span", {
      className: pageRecordCls
    }, typeof renderTotal === 'function' ? renderTotal(total) : format(localeTotal, {
      total: total
    }));
  };

  return React.createElement("div", _objectSpread({
    className: cls
  }, others), getTotal(), renderPageNumber(), renderPageSizeSelector(), showJump && renderJumpTo());
}
Pager.Simple = PagerSimple;